// 枚举C++函数调用
const PCFunction = {
    startDownload: 0, // 开始下载
    pauseDownload: 1, // 暂停下载
    resetDownload: 2, // 继续下载
    getGamesList: 3, // 获取本地全部已下载/下载中的游戏
    saveData: 4, // 存储数据
    readData: 5, // 读取数据
    launchGame: 6, // 启动游戏
    removeGame: 7, // 删除游戏
    operateFile: 8, // 文件操作，具体类型看 OperateFileType
    createShortcut: 9, // 创建桌面快捷方式
}

// 定义PCFunction = operateFile时的文件操作类型
const OperateFileType = {
    fileCreate: 0, // 新建文件
    fileRemove: 1, // 删除文件
    fileRename: 2, // 修改文件名
    fileModify: 3, // 修改文件内容
}

// 定义游戏状态
const GameStatus = {
    gameUnload: 0, // 未安装
    gameLoading: 1, // 下载中
    gamePause: 2, // 已暂停
    gameInstalling: 3, // 安装中
    gameInstalled: 4, // 已安装
};

function getStatusText(status) {
    switch (status) {
        case 0: return '未安装';
        case 1: return '下载中';
        case 2: return '已暂停';
        case 3: return '安装中';
        case 4: return '已安装';
        default:
            break;
    }
    return '未知状态';
}

const gameDownload = [
    {
        gameId: '100001',
        name: '三国志2',
        btn: "开始下载",
        disabled: false,
        status: 0,
        spanTxt: "",
        progress: 0
    },
    {
        gameId: '100002',
        name: '三国战纪119 完美版',
        btn: "开始下载",
        disabled: false,
        status: 0,
        spanTxt: "",
        progress: 0
    },
    {
        gameId: '100003',
        name: '恐龙快打',
        btn: "开始下载",
        disabled: false,
        status: 0,
        spanTxt: "",
        progress: 0
    },
    {
        gameId: '100004',
        name: '西游释厄传',
        btn: "开始下载",
        disabled: false,
        status: 0,
        spanTxt: "",
        progress: 50
    }
]

// 定义设置下载进度的函数给C++调用
function setDownloadStatus(gameId, status, percent, speed) {
    // let params = "gameid=" + gameId + " sttus=" + status + " percent=" + percent + " speed=" + speed;
    // let str = '#' + gameId + '.game_download_btn';
    // const button:any = document.getElementById(gameId)
    const arr = gameDownload
    arr.forEach((item, index) => {
        if (item.gameId == gameId) {
            gameDownload[index].btn = getStatusText(status);
            let disable = false;
            if (status === GameStatus.gameInstalling || status === GameStatus.gameInstalled) {
                disable = true;
            }
            gameDownload[index].disabled = disable;
            gameDownload[index].status = status;
            if (status === GameStatus.gameLoading) {
                gameDownload[index].spanTxt = speed + 'kb/s';
                gameDownload[index].progress = percent;
            } else if (status === GameStatus.gameInstalling || status === GameStatus.gameInstalled) {
                gameDownload[index].spanTxt = '';
                gameDownload[index].progress = 100;
            } else if (status === GameStatus.gameUnload) {
                gameDownload[index].spanTxt = '';
                gameDownload[index].progress = 0;
            }
        }
    })
}

// 测试数据
const gameList = [
    {
        gameId: '100001',
        name: '三国志2',
        desc: '还记得在街机房和哥们通宵的时候吗？',
        exe: 'app.exe',
        version: '1.0.1',
        url: 'http://10.41.1.7/私服客户端.zip',
        icoUrl: 'http://ctimg2018.myyx618.com/upload/images/58/b7/58b77d069477509543b62259b67b3384.png',
    },
    {
        gameId: '100002',
        name: '三国战纪119 完美版',
        desc: '小时候为了玩一把，要排队一小时！',
        exe: 'app.exe',
        version: '1.0.1',
        url: 'http://ctappyf2020.abab668.com/appsite/simulator/mame/kovplus_1.2_5.1.25_106.zip',
        icoUrl: 'http://ctimg2018.myyx618.com/upload/images/80/2b/802b4c5454fcac104aa6cfcecdfdb200.png',
    },
    {
        gameId: '100003',
        name: '恐龙快打',
        desc: '偷钱都要玩的儿时闯关游戏',
        exe: 'app.exe',
        version: '1.0.1',
        url: 'http://ctappyf2020.abab668.com/appsite/simulator/mame/dino_1_2.1.23_127.zip',
        icoUrl: 'http://ctimg2018.myyx618.com/upload/images/d8/84/d884a7696e70f49e8b3657c18e896c43.png',
    },
    {
        gameId: '100004',
        name: '西游释厄传',
        desc: '四人合作闯西游，每次都要排队半小时',
        exe: 'app.exe',
        version: '1.0.1',
        url: 'http://ctappyf2020.abab668.com/appsite/simulator/mame/orlegend_1_1.1.19_75.zip',
        icoUrl: 'http://ctimg2018.myyx618.com/upload/images/7d/81/7d8163629d23219c80c691833a056ca8.png',
    }
];
(window as any).gameList = gameList

function testDownload(id, status, item) {
    if (status === GameStatus.gameUnload) { // 开始下载
        // gameList.forEach((element, index) => {
        //     if (element.gameId === id) {
        //         (window as any).pc.handle(JSON.stringify(gameList[index]));
        //     }
        // });
        const data = (window as any).pc.handle(JSON.stringify(item));
    } else if (status === GameStatus.gameLoading) { // 暂停
        const params: any = {};
        params.function = PCFunction.pauseDownload;
        params.gameId = id;
        const data = (window as any).pc.handle(JSON.stringify(params));
    } else if (status === GameStatus.gamePause) { // 继续下载
        const params: any = {};
        params.function = PCFunction.resetDownload;
        params.gameId = id;
        const data = (window as any).pc.handle(JSON.stringify(params));
    }
    // setDownloadStatus(id, GameStatus.gameLoading, 0, 0);
}

// 页面记载完成后，获取客户端安装信息，更新页面状态
// window.onload = () => {
//     // 获取应用列表信息，设置页面状态
//     let params: any = {};
//     params.function = PCFunction.getGamesList;
//     const data = (window as any).pc.handle(JSON.stringify(params));
//     params = JSON.parse(data);
//     if (params.code != 0) {
//         alert("获取应用列表下载信息失败：" + params.msg);
//         return;
//     }
//     // 下载完成列表
//     const finishList = params.data.finish;
//     finishList.forEach((element, index) => {
//         setDownloadStatus(finishList[index].gameId, finishList[index].status, 100, 0);
//     });
//     // 下载中列表
//     const loadList = params.data.loading;
//     loadList.forEach((element, index) => {
//         setDownloadStatus(loadList[index].gameId, loadList[index].status, loadList.percent, 0);
//     });
// }
// 获取游戏安装信息
function testGamesList() {
    const params: any = {};
    params.function = PCFunction.getGamesList;
    const data = (window as any).pc.handle(JSON.stringify(params));
    return data;
}
// 保存数据
function testSaveData(value) {
    const params: any = {};
    params.key = "login";
    params.value = value; // 最大限制1024个字节
    params.function = PCFunction.saveData;
    const data = (window as any).pc.handle(JSON.stringify(params));
}

// 读取数据
function testReadData() {
    let params: any = {};
    params.key = "login";
    params.function = PCFunction.readData;
    const data = (window as any).pc.handle(JSON.stringify(params));
    params = JSON.parse(data);
    return params.data;
}

// 启动游戏
function testLaunchGame(id) {
    const params: any = {};
    params.gameId = id;
    params.function = PCFunction.launchGame;
    const data = (window as any).pc.handle(JSON.stringify(params));
    return data;
}

// 删除游戏
function testRemoveGame(id) {
    const params: any = {};
    params.gameId = id;
    params.function = PCFunction.removeGame;
    const data = (window as any).pc.handle(JSON.stringify(params));
    return data;
}

// 新建文件
function testCreateFile(fileName) {
    if (fileName.length === 0) {
        alert("先输入文件名！");
        return;
    }
    const params: any = {};
    params.function = PCFunction.operateFile;
    params.type = OperateFileType.fileCreate;
    params.fileName = fileName; // 创建的文件名不能有：\\/:*?<>|一
    const data = (window as any).pc.handle(JSON.stringify(params));
    return data;
}

// 删除文件
function testDeleteFile(fileName) {
    if (fileName.length === 0) {
        alert("先输入文件名！");
        return;
    }
    const params: any = {};
    params.gameId = 100001;
    params.function = PCFunction.operateFile;
    params.type = OperateFileType.fileRemove;
    params.fileName = fileName; // 创建的文件名不能有：\\/:*?<>|一
    const data = (window as any).pc.handle(JSON.stringify(params));
    return data;
}

// 修改文件名
function testRenameFile(oldName, newName) {
    if (oldName.length === 0) {
        alert("先输入源文件名！");
        return;
    }
    if (newName.length === 0) {
        alert("先输入目标文件名！");
        return;
    }
    const params: any = {};
    params.gameId = 100001;
    params.function = PCFunction.operateFile;
    params.type = OperateFileType.fileRename;
    params.oldName = oldName;
    params.newName = newName; // 创建的文件名不能有：\\/:*?<>|一
    const data = (window as any).pc.handle(JSON.stringify(params));
    return data;
}

// 修改文件内容
function testModifyFile(id, fileName, content) {
    if (fileName.length === 0) {
        alert("先输入源文件名！");
        return;
    }
    if (content.length === 0) {
        alert("先输入目标文件名！");
        return;
    }
    const params: any = {};
    params.gameId = id;
    params.function = PCFunction.operateFile;
    params.type = OperateFileType.fileModify;
    params.fileName = fileName; // 创建的文件名不能有：\\/:*?<>|一
    params.content = content;
    const data = (window as any).pc.handle(JSON.stringify(params));
    return data;
}

function testCreateShortcut(id, fileName) {
    const params: any = {};
    params.function = PCFunction.createShortcut;
    params.gameId = id;
    params.fileName = fileName; // 快捷方式名
    const data = (window as any).pc.handle(JSON.stringify(params));
    return data;
}

const pc = {
    gameDownload,
    // 下载
    pcTestDownload: (id, status, item) => testDownload(id, status, item),
    // 获取游戏安装信息
    pcTestGamesList: () => testGamesList(),
    // 保存数据
    pcTestSaveData: (value) => testSaveData(value),
    // 读取数据
    pcTestReadData: () => testReadData(),
    // 启动游戏
    pcTestLaunchGame: (id) => testLaunchGame(id),
    // 删除游戏
    pcTestRemoveGame: (id) => testRemoveGame(id),
    // 新建文件
    pcTestCreateFile: (fileName) => testCreateFile(fileName),
    // 删除文件
    pcTestDeleteFile: (fileName) => testDeleteFile(fileName),
    // 修改文件名
    pcTestRenameFile: (oldName, newName) => testRenameFile(oldName, newName),
    // 修改文件内容
    pcTestModifyFile: (id, fileName, content) => testModifyFile(id, fileName, content),
    // 创建快捷方式
    pcTestCreateShortcut: (id, fileName, content) => testCreateShortcut(id, fileName)
}

export default pc;
